var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThreeDotVertical({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2,
    height: 16,
    viewBox: "0 0 2 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 -4.37114e-08C1.55228 -1.95702e-08 2 0.397969 2 0.888889L2 2.66667L5.98692e-07 2.66667L6.76401e-07 0.888889C6.9786e-07 0.397969 0.447716 -6.78525e-08 1 -4.37114e-08ZM2.87856e-07 9.77778L4.43274e-07 6.22222L2 6.22222L2 9.77778L2.87856e-07 9.77778ZM5.47281e-08 15.1111L1.32437e-07 13.3333L2 13.3333L2 15.1111C2 15.602 1.55228 16 1 16C0.447715 16 3.32693e-08 15.602 5.47281e-08 15.1111Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDotVertical);
export default __webpack_public_path__ + "static/media/three-dot-vertical.81db5c7a47917960759a333aff9e9489.svg";
export { ForwardRef as ReactComponent };